import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import DesignServicesOutlinedIcon from "@mui/icons-material/DesignServicesOutlined";
import PrecisionManufacturingOutlinedIcon from "@mui/icons-material/PrecisionManufacturingOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import BadgeOutlinedIcon from "@mui/icons-material/BadgeOutlined";
import { hasCatalogPermission } from "../../constants/navCatalog";

export const HELP_SECTIONS = [
  {
    id: "start",
    icon: InfoOutlinedIcon,
    items: [
      { id: "whatIs" },
      { id: "sidebar", image: "sidebar" },
      {
        id: "myDashboard",
        route: "/mi-dashboard",
        match: ["/mi-dashboard"],
        permissionKey: null,
        related: ["tasks", "novedades", "estimates"],
      },
      {
        id: "dashboardGeneral",
        route: "/dashboard",
        match: ["/dashboard"],
        permissionKey: "Permiso_Dashboard",
      },
      {
        id: "dashboardDesign",
        route: "/dashboardDesigns",
        match: ["/dashboardDesigns"],
        permissionKey: "Permiso_DashboardDesigns",
      },
      {
        id: "ranking",
        route: "/rankingVentas",
        match: ["/rankingVentas"],
        permissionKey: "Permiso_RankingVenta",
      },
      {
        id: "organigrama",
        route: "/organigrama",
        match: ["/organigrama"],
        permissionKey: "Permiso_Organigrama",
      },
      {
        id: "novedades",
        route: "/novedadesInsertar",
        match: ["/novedadesInsertar"],
        permissionKey: "Permiso_Novedades",
      },
    ],
  },
  {
    id: "crm",
    icon: PeopleOutlinedIcon,
    items: [
      {
        id: "clients",
        route: "/customers",
        match: ["/customers"],
        permissionKey: "Permiso_Clients",
        related: ["kanban", "projects", "skills", "meetings"],
      },
      {
        id: "meetings",
        route: "/reuniones",
        match: ["/reuniones"],
        permissionKey: "Permiso_Reuniones",
        related: ["clients", "samples", "skillsTasks"],
      },
      {
        id: "kanban",
        route: "/kanban",
        match: ["/kanban"],
        permissionKey: "Permiso_KambanClientes",
        related: ["clients", "projects"],
      },
      {
        id: "projects",
        route: "/kanbanproyectos",
        match: ["/kanbanproyectos", "/proyectos"],
        permissionKey: "Permiso_KambanProyectos",
        related: ["clients", "tasks"],
      },
      {
        id: "tasks",
        route: "/tareas",
        match: ["/tareas"],
        permissionKey: "Permiso_ToDoListGlobal",
        related: ["calendar", "myDashboard", "projects"],
      },
      {
        id: "calendar",
        route: "/calendar",
        match: ["/calendar"],
        permissionKey: "Permiso_Task",
        related: ["tasks"],
      },
    ],
  },
  {
    id: "development",
    icon: DesignServicesOutlinedIcon,
    items: [
      {
        id: "designs",
        route: "/producttree",
        match: ["/producttree"],
        permissionKey: "Permiso_Designs",
        related: ["samples", "estimates", "designCalendar"],
      },
      {
        id: "designCalendar",
        route: "/design-calendar",
        match: ["/design-calendar"],
        permissionKey: "Permiso_CalendarioAgus",
        related: ["designs", "estimates"],
      },
      {
        id: "samples",
        route: "/muestras",
        match: ["/muestras"],
        permissionKey: "Permiso_Samples",
        related: [
          "designs",
          "lookbook",
          "samplesLocation",
          "estimates",
          "meetings",
        ],
      },
      {
        id: "lookbook",
        route: "/muestras1",
        match: ["/muestras1"],
        permissionKey: "Permiso_Samples",
        related: ["samples"],
      },
      {
        id: "estimates",
        route: "/estimates",
        match: ["/estimates"],
        permissionKey: "Permiso_Estimates",
        related: ["designs", "samples", "unibox", "produccion"],
      },
      {
        id: "articulos",
        route: "/articulosA3",
        match: ["/articulosA3"],
        permissionKey: "Permiso_Articulos",
        related: ["produccion"],
      },
      {
        id: "produccion",
        route: "/produccionSummary",
        match: ["/produccionSummary"],
        permissionKey: "Permiso_PedidosA3",
        related: ["logistica", "estimates", "cpGlobal"],
      },
      {
        id: "logistica",
        route: "/gestionLogisticaPedidos",
        match: ["/gestionLogisticaPedidos"],
        permissionKey: "Permiso_PedidosA3",
        related: ["produccion", "cpGlobal"],
      },
    ],
  },
  {
    id: "manufacturing",
    icon: PrecisionManufacturingOutlinedIcon,
    items: [
      {
        id: "cpUnitario",
        route: "/criticalPath",
        match: ["/criticalPath"],
        permissionKey: "Permiso_CriticalPathUnido",
        related: ["cpGlobal", "cpGantt"],
      },
      {
        id: "cpGlobal",
        route: "/criticalPathHorizontal",
        match: ["/criticalPathHorizontal"],
        permissionKey: "Permiso_CriticalPathGlobal",
        allowForProveedor: true,
        related: ["cpGantt", "cpNotes", "logistica"],
      },
      {
        id: "cpGantt",
        route: "/criticalPathHorizontal1",
        match: ["/criticalPathHorizontal1"],
        permissionKey: "Permiso_CriticalPathGlobal",
        allowForProveedor: true,
        image: "criticalPath",
        related: ["cpGlobal", "cpNotes"],
      },
      {
        id: "cpNotes",
        route: "/notasResumen",
        match: ["/notasResumen"],
        permissionKey: "Permiso_SeeAllNotes",
        related: ["cpGlobal"],
      },
    ],
  },
  {
    id: "resources",
    icon: Inventory2OutlinedIcon,
    items: [
      {
        id: "coloresMuestras",
        route: "/colores-muestras",
        match: ["/colores-muestras"],
        permissionKey: "Permiso_Colores",
        related: ["colores", "samples"],
      },
      {
        id: "colores",
        route: "/colores",
        match: ["/colores"],
        permissionKey: "Permiso_Colores",
        related: ["coloresMuestras"],
      },
      {
        id: "materialoteca",
        route: "/materialoteca",
        match: ["/materialoteca"],
        permissionKey: "Permiso_Materialoteca",
        related: ["ferias", "factories"],
      },
      {
        id: "ferias",
        route: "/ferias",
        match: ["/ferias"],
        permissionKey: "Permiso_Ferias",
        related: ["suppliers", "factories", "materialoteca"],
      },
      {
        id: "suppliers",
        route: "/proveedores",
        match: ["/proveedores"],
        permissionKey: "Permiso_Suppliers",
        related: ["factories", "estimates"],
      },
      {
        id: "factories",
        route: "/fabricas",
        match: ["/fabricas"],
        permissionKey: "Permiso_Suppliers",
        related: ["suppliers", "ferias"],
      },
      {
        id: "samplesLocation",
        route: "/muestrasUbicacion",
        match: ["/muestrasUbicacion"],
        permissionKey: "Permiso_SamplesLocation",
        related: ["samples", "samplesMovement"],
      },
      {
        id: "samplesMovement",
        route: "/muestrasMovimientoCamara",
        match: ["/muestrasMovimientoCamara"],
        permissionKey: "Permiso_SamplesLocation",
        related: ["samplesLocation"],
      },
    ],
  },
  {
    id: "ai",
    icon: AutoAwesomeOutlinedIcon,
    items: [
      {
        id: "aiSearch",
        route: "/aiSearch",
        match: ["/aiSearch"],
        permissionKey: "Permiso_Nasdesign",
        related: ["presentaciones", "aiDesigns", "skills"],
      },
      {
        id: "presentaciones",
        route: "/presentacionesSearch",
        match: ["/presentacionesSearch"],
        permissionKey: "Permiso_PresentacionesAI",
        related: ["aiDesigns", "aiSearch", "designs"],
      },
      {
        id: "aiDesigns",
        route: "/aiDesigns",
        match: ["/aiDesigns"],
        permissionKey: "Permiso_PresentacionesAI",
        related: ["presentaciones", "aiSearch", "designs"],
      },
      {
        id: "skills",
        route: "/skills",
        match: ["/skills"],
        permissionKey: "Permiso_Skills",
        related: ["skillsTasks", "clients", "meetings"],
      },
      {
        id: "skillsTasks",
        route: "/skills/tareas",
        match: ["/skills/tareas"],
        permissionKey: "Permiso_TareasAgentes",
        related: ["skills", "meetings"],
      },
      {
        id: "conocimiento",
        route: "/conocimiento",
        match: ["/conocimiento"],
        permissionKey: "Permiso_conocimiento",
        related: ["crearMensajes"],
      },
      {
        id: "crearMensajes",
        route: "/crearMensajes",
        match: ["/crearMensajes"],
        permissionKey: "Permiso_CrearMensajes",
        related: ["conocimiento"],
      },
    ],
  },
  {
    id: "finance",
    icon: AccountBalanceOutlinedIcon,
    items: [
      {
        id: "insights",
        route: "/insights",
        match: ["/insights"],
        permissionKey: "Permiso_InsightsEjecutivos",
      },
      {
        id: "informesEc",
        route: "/informes-ec",
        match: ["/informes-ec"],
        permissionKey: "Permiso_InformesEC",
      },
      {
        id: "pyg",
        route: "/pygdebug",
        match: ["/pygdebug"],
        permissionKey: "Permiso_PyG",
        related: ["analitica", "cashflow"],
      },
      {
        id: "analitica",
        route: "/pyg-analitico/fusion",
        match: ["/pyg-analitico/fusion"],
        permissionKey: "Permiso_PyG",
        related: ["analiticaMarca", "pyg"],
      },
      {
        id: "analiticaMarca",
        route: "/pyg-analitico/fusion/por-marca",
        match: ["/pyg-analitico/fusion/por-marca"],
        permissionKey: "Permiso_PyG",
        related: ["analitica"],
      },
      {
        id: "nmlPyg",
        route: "/pyg-analitico/nml_spain",
        match: ["/pyg-analitico/nml_spain"],
        permissionKey: "Permiso_NMLFinanzas",
        related: ["nmlBalance"],
      },
      {
        id: "nmlBalance",
        route: "/balance-analitico/nml_spain",
        match: ["/balance-analitico/nml_spain"],
        permissionKey: "Permiso_NMLFinanzas",
        related: ["nmlPyg"],
      },
      {
        id: "nmlSuzhouCp",
        route: "/nml/suzhou/critical-path",
        match: ["/nml/suzhou/critical-path", "/nml-suzhou/critical-path"],
        permissionKey: ["Permiso_NmlSuzhou", "Permiso_NmlSuzhouCliente"],
        nmlBoard: "SUZHOU",
      },
      {
        id: "nmlTurkeyCp",
        route: "/nml/turkey/critical-path",
        match: ["/nml/turkey/critical-path"],
        permissionKey: ["Permiso_NmlTurkey", "Permiso_NmlSuzhouCliente"],
        nmlBoard: "TURKEY",
      },
      {
        id: "nmlGuangzhouCp",
        route: "/nml/guangzhou/critical-path",
        match: ["/nml/guangzhou/critical-path", "/nml/wangzhou/critical-path"],
        permissionKey: ["Permiso_NmlGuangzhou", "Permiso_NmlSuzhouCliente"],
        nmlBoard: "GUANGZHOU",
      },
      {
        id: "cashflow",
        route: "/cashflow",
        match: ["/cashflow"],
        permissionKey: "Permiso_CashFlow",
        related: ["pyg", "tpv"],
      },
      {
        id: "tpv",
        route: "/tpv",
        match: ["/tpv"],
        permissionKey: "Permiso_Tpv",
        related: ["cashflow"],
      },
      {
        id: "pedidosVenta",
        route: "/pedidosVenta",
        match: ["/pedidosVenta"],
        permissionKey: "Permiso_PedidosVenta",
        related: ["ventasTotales", "produccion"],
      },
      {
        id: "ventasTotales",
        route: "/ventasTotales",
        match: ["/ventasTotales"],
        permissionKey: "Permiso_VentaTotal",
        related: ["pedidosVenta", "ranking"],
      },
      {
        id: "margenes",
        route: "/tablaReducida",
        match: ["/tablaReducida"],
        permissionKey: "Permiso_MargenesVenta",
      },
      {
        id: "expenses",
        route: "/expenses",
        match: ["/expenses"],
        permissionKey: "Permiso_Expenses",
        related: ["expensesUser"],
      },
      {
        id: "expensesUser",
        route: "/expenses-user/notes",
        match: ["/expenses-user"],
        permissionKey: "Permiso_ExpensesNew",
        related: ["expenses"],
      },
      {
        id: "nominas",
        route: "/nominas",
        match: ["/nominas"],
        permissionKey: "Permiso_Nominas",
      },
      {
        id: "brands",
        route: "/gestionmarcas",
        match: ["/gestionmarcas"],
        permissionKey: "Permiso_Brands",
      },
      {
        id: "currency",
        route: "/currencyManager",
        match: ["/currencyManager"],
        permissionKey: "Permiso_CurrencyManager",
      },
      {
        id: "duties",
        route: "/dutties",
        match: ["/dutties"],
        permissionKey: "Permiso_Duties",
        related: ["ddp"],
      },
      {
        id: "ddp",
        route: "/ddp-import-tarifas",
        match: ["/ddp-import-tarifas"],
        permissionKey: "Permiso_Duties",
        related: ["duties"],
      },
      {
        id: "cbm",
        route: "/volumenPrenda",
        match: ["/volumenPrenda"],
        permissionKey: "Permiso_Cbm",
      },
    ],
  },
  {
    id: "user",
    icon: BadgeOutlinedIcon,
    items: [
      {
        id: "unibox",
        route: "/unibox",
        match: ["/unibox"],
        permissionKey: "Permiso_Emails",
        related: ["uniboxStats", "estimates"],
      },
      {
        id: "uniboxStats",
        route: "/unibox-stats",
        match: ["/unibox-stats"],
        permissionKey: "Permiso_UniboxStats",
        related: ["unibox"],
      },
      {
        id: "booking",
        route: "/booking",
        match: ["/booking"],
        permissionKey: "Permiso_Booking",
      },
      {
        id: "visitCard",
        route: "/users",
        match: ["/users"],
        permissionKey: "Permiso_UserVisitCard",
      },
      {
        id: "jobDescription",
        route: "/jobDescriptionPage",
        match: ["/jobDescriptionPage"],
        permissionKey: "Permiso_JobDescription",
        related: ["organigrama"],
      },
      {
        id: "timeTracking",
        route: "/control-horario",
        match: ["/control-horario"],
        permissionKey: ["Permiso_Fichaje", "Permiso_ControlHorario_RRHH"],
      },
      {
        id: "userDocs",
        route: "/user-documents",
        match: ["/user-documents"],
        permissionKey: "Permiso_SubirDocsUser",
      },
      {
        id: "permissions",
        route: "/usersPermissions",
        match: ["/usersPermissions"],
        permissionKey: "Permiso_Users",
      },
    ],
  },
];

/** true si el usuario puede abrir la ruta del ítem de ayuda */
export function canAccessHelpItem(
  item,
  permissions = {},
  { hasProveedorLimit = false } = {},
) {
  if (!item?.route) return false;
  return hasCatalogPermission(item, permissions, { hasProveedorLimit });
}

export function findHelpMatch(pathname) {
  if (!pathname) return { sectionId: "start", itemId: "whatIs" };

  const scored = [];
  HELP_SECTIONS.forEach((section) => {
    section.items.forEach((item) => {
      const matches = (item.match || []).filter(
        (m) => pathname === m || pathname.startsWith(`${m}/`),
      );
      if (matches.length === 0) return;
      const len = Math.max(...matches.map((m) => m.length));
      scored.push({ sectionId: section.id, itemId: item.id, len });
    });
  });

  if (scored.length === 0) return { sectionId: "start", itemId: "whatIs" };
  scored.sort((a, b) => b.len - a.len);
  return { sectionId: scored[0].sectionId, itemId: scored[0].itemId };
}

export function findHelpItem(itemId) {
  for (const section of HELP_SECTIONS) {
    const item = section.items.find((i) => i.id === itemId);
    if (item) return { section, item };
  }
  return null;
}

function asStringArray(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string" && value && !value.startsWith("help.")) {
    return [value];
  }
  return [];
}

export function getHelpItemCopy(t, itemId) {
  const base = `help.items.${itemId}`;
  return {
    title: t(`${base}.title`),
    what: t(`${base}.what`),
    how: t(`${base}.how`),
    rules: asStringArray(
      t(`${base}.rules`, { returnObjects: true, defaultValue: [] }),
    ),
    steps: asStringArray(
      t(`${base}.steps`, { returnObjects: true, defaultValue: [] }),
    ),
  };
}

export function itemMatchesSearch(t, item, query) {
  if (!query) return true;
  const copy = getHelpItemCopy(t, item.id);
  const haystack = [
    copy.title,
    copy.what,
    copy.how,
    ...copy.rules,
    ...copy.steps,
  ]
    .join(" ")
    .toLowerCase();
  return haystack.includes(query);
}
